// extracted by mini-css-extract-plugin
module.exports = {"contentRow":"Auction_contentRow__tIRGK","shareContainer":"Auction_shareContainer__3ZG0z","detailsRow":"Auction_detailsRow__1VAy6"};